export default __webpack_public_path__ + "static/media/screen_link.b446b071.svg";